<template lang='pug'>
  router-link.combo.link.component( :to='to' :title='title' )
    slot
      .icon
        slot(name='icon')
      .text
        slot(name='text')
</template>

<script>
  export default {
    name: 'combo.link.component',

    props: {
      to: { type: [Object, String], required: true },
      title: { type: String, default: 'link' }
    }
  }
</script>

<style scoped lang='stylus'>
  .combo
    padding 8px 4px
    text-shadow inherit
    transition transform 320ms
    color inherit
    display flex
    align-items baseline
    &:hover
      box-shadow 0 0 16px 0px rgba( 0 0 0 .1 )
      background rgba( 255 255 255 .75 )
    &:active
      transform scale(.88)
    &:active, &:focus
      outline none

  .combo.on-medium
    &:hover
      background rgba( 255 255 255 .25 )

  .icon, .text
    padding 0 12px

  .icon
    font-size 1.5em
    border-right 1px dotted rgba( 0 0 0 .2 )
    position relative
    top 1.5px

  .combo.on-medium
    &:hover
      background rgba( 240 240 240 .1 )
      color rgb( 240 240 240 )
    .icon
      border-color rgba( 0 0 0 .5 )
  
  .combo.vertical
    flex-direction column
    .icon
      border-right 0
      font-size 3.2em
      margin-bottom 4px
  
  .combo.centered
    align-items center
    justify-content center
</style>
